import {
  CONVERSATION_MESSAGE_RECEIVED,
  CARE_CONVERSATION_MESSAGE_RECEIVED,
  SUPPORT_MESSAGE_RECEIVED,
  CARE_CONVERSATION_MESSAGE_NOTIFICATION,
  PATIENT_CHECK_IN_EVENT_RECEIVED,
  ISSUE_NOTIFICATION_RECEIVED,
  PATIENT_CHECKED_IN,
  PATIENT_ONLINE_STATUSES_RECEIVED,
} from './constants';

import { createAction } from '@reduxjs/toolkit';

// events for each type of connection

export const conversationEvents = ['message'];

export const careConversationEvents = ['message', 'notification'];

export const supportMessageEvents = ['message'];

export const examRoomEvents = ['patientCheckedIn'];

export const notificationEvents = ['issueNotification', 'checkedInNotification', 'patientOnlineStatuses'];

// relationship between event and action

export const conversationActionType = {
  message: CONVERSATION_MESSAGE_RECEIVED,
};

export const careConversationActionType = {
  message: CARE_CONVERSATION_MESSAGE_RECEIVED,
  notification: CARE_CONVERSATION_MESSAGE_NOTIFICATION,
};

export const supportMessageActionType = {
  message: SUPPORT_MESSAGE_RECEIVED,
};

export const patientCheckInActionType = {
  patientCheckedIn: PATIENT_CHECK_IN_EVENT_RECEIVED,
};

export const notificationReceivedActionType = {
  issueNotification: ISSUE_NOTIFICATION_RECEIVED,
  checkedInNotification: PATIENT_CHECK_IN_EVENT_RECEIVED,
  patientOnlineStatusReceived: PATIENT_ONLINE_STATUSES_RECEIVED,
};
